export const SET_FILTERS = "SET_FILTERS";
export const SET_ALL_FILTERS = "SET_ALL_FILTERS";
export const RESET_FILTERS = "RESET_FILTERS";